import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingSetWrapper: {
    padding: theme.spacing(0.5, 1),
    borderBottom: `1px solid ${theme.palette.border.main}`,

    '& .MuiOutlinedInput-root.MuiInputBase-root': {
      paddingLeft: '0 !important',
    },
  },
  trainingSetWrapperWithSplitBySideExercise: {},
  started: {
    background: theme.palette.exerciseStatus.started,
  },
  notStartedOddLine: {
    background: theme.palette.exerciseStatus.notStartedOddLine,
  },
  notStartedEvenLine: {
    background: theme.palette.exerciseStatus.notStartedEvenLine,
  },
  doLateOddLine: {
    background: theme.palette.exerciseStatus.doLateOddLine,
  },
  doLateEvenLine: {
    background: theme.palette.exerciseStatus.doLateEvenLine,
  },
  skippedOddLine: {
    // background: theme.palette.exerciseStatus.skippedOddLine,
    background: theme.palette.exerciseStatus.skippedOddLine,
  },
  skippedEvenLine: {
    background: theme.palette.exerciseStatus.skippedEvenLine,
  },
  finishedOddLine: {
    background: theme.palette.exerciseStatus.finishedOddLine,
  },
  finishedEvenLine: {
    background: theme.palette.exerciseStatus.finishedEvenLine,
  },

  itemDragging: {
    border: `1px dashed ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primaryTransparent,

    '& > div': {
      display: 'none',
    },
  },
  itemDragTarget: {
    border: `1px dashed ${theme.palette.primary.main}`,
    // backgroundColor: theme.palette.error.light,
  },
  menuContainer: {
    width: '150px',
    maxWidth: '150px',
    minWidth: '150px',
  },
  menuItemContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },

  sideLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: theme.spacing(2),
    height: theme.spacing(2),
    borderRadius: '4px',
    marginRight: theme.spacing(0.5),
  },
  rightSideLabel: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primarySamitransparent,
  },
  leftSideLabel: {
    color: theme.palette.font.secondary,
    backgroundColor: theme.palette.secondary.main,
  },
}));
